import { Fragment } from 'react';
import AccordionCohabitant from './cohabitant';
import Cohabitation from './cohabitation';
import EditData from './edit-data';
import AccordionFamilyCoexistenceList from './list';

const DeclarationCohabitation = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionFamilyCoexistenceList />
      <EditData />
      <AccordionCohabitant />
      <Cohabitation />
    </Fragment>
  );
};

DeclarationCohabitation.displayName = 'Declaration Cohabitation component';

export default DeclarationCohabitation;
